
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer/add",
      function () {
        return require("private-next-pages/customer/add.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer/add"])
      });
    }
  